/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/router';
import * as i2 from '../../../../app/components/services/services.component';
const styles_ServicesComponent:any[] = [''];
export const RenderType_ServicesComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:0,
    styles:styles_ServicesComponent,data:{}});
export function View_ServicesComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(212992,(null as any),0,i1.RouterOutlet,[i1.ChildrenOutletContexts,i0.ViewContainerRef,
          i0.ComponentFactoryResolver,[8,(null as any)],i0.ChangeDetectorRef],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export function View_ServicesComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'kts-services',
      ([] as any[]),(null as any),(null as any),(null as any),View_ServicesComponent_0,
      RenderType_ServicesComponent)),i0.ɵdid(114688,(null as any),0,i2.ServicesComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ServicesComponentNgFactory:i0.ComponentFactory<i2.ServicesComponent> = i0.ɵccf('kts-services',
    i2.ServicesComponent,View_ServicesComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvWWktWXUvRG9jdW1lbnRzL0FjdHVhbCBEb2N1bWVudHMvS2F0aXNvL2thdGlzby9zcmMvYXBwL2NvbXBvbmVudHMvc2VydmljZXMvc2VydmljZXMuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0M6L1VzZXJzL1lpLVl1L0RvY3VtZW50cy9BY3R1YWwgRG9jdW1lbnRzL0thdGlzby9rYXRpc28vc3JjL2FwcC9jb21wb25lbnRzL3NlcnZpY2VzL3NlcnZpY2VzLmNvbXBvbmVudC50cyIsIm5nOi8vL0M6L1VzZXJzL1lpLVl1L0RvY3VtZW50cy9BY3R1YWwgRG9jdW1lbnRzL0thdGlzby9rYXRpc28vc3JjL2FwcC9jb21wb25lbnRzL3NlcnZpY2VzL3NlcnZpY2VzLmNvbXBvbmVudC50cy5TZXJ2aWNlc0NvbXBvbmVudC5odG1sIiwibmc6Ly8vQzovVXNlcnMvWWktWXUvRG9jdW1lbnRzL0FjdHVhbCBEb2N1bWVudHMvS2F0aXNvL2thdGlzby9zcmMvYXBwL2NvbXBvbmVudHMvc2VydmljZXMvc2VydmljZXMuY29tcG9uZW50LnRzLlNlcnZpY2VzQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PiIsIjxrdHMtc2VydmljZXM+PC9rdHMtc2VydmljZXM+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7YUFBQTtzQ0FBQTtVQUFBO0lBQUE7Ozs7b0JDQUE7TUFBQTtrQ0FBQSxVQUFBO01BQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/src/$$_gendir/app/components/services/services.component.ngfactory.ts